module.exports = __webpack_public_path__ + "static/danish-c64b9b027648dce105cc493aa2a20883.png";